import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {LessonItemComponent} from '../../../components/learning/lesson-item/lesson-item.component';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';

@Component({
  selector: 'app-games-level-lessons',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    LessonItemComponent,
    SpinnerComponent
  ],
  templateUrl: './games-level-lessons.component.html',
  styleUrls: ['./games-level-lessons.component.scss']
})
export class GamesLevelLessonsComponent implements OnInit {

  @Input() level: any;
  @Input() lessons: any;

  loader = true;
  currentTab: number;

  constructor(
    private activeModal: NgbActiveModal
  ) {
  }

  async ngOnInit() {
    // this.currentTab = this.lessons[0].id;
    this.loader = false;
  }

  trackById(index: number, item: any) { return item.id; }

  close() {
    this.activeModal.close();
  }

  isActiveTab(lessonId: number): boolean {
    return this.currentTab === lessonId;
  }

  toggleTab(lessonId: number) {
    this.currentTab = lessonId;
  }

  getCurrentLesson(): any {
    return this.lessons.find((x: any) => x.id === this.currentTab);
  }
}
